import "../../../shared/config/global.js";
import "../../../assets/css/bootstrap.css";
import Navbar from "../../../shared/layout/Navbar";
import { getStorage, format_date, float, DocumentSettingBase } from "../../../shared/index.js";
import React from "react";
import { Modal } from "react-bootstrap";
import LOGO from "../../../assets/images/logo.png";
import Switch from "react-switch";
import Resizer from "react-image-file-resizer";

const size = {
  A4: { width: 1116, height: 789, zoom: 0.7 }, A5: { width: 1116, height: 792, zoom: 0.5 },
  "4.5 x 5.5 นิ้ว": { width: 1116, height: 685, zoom: 0.385 }, "9 x 11 นิ้ว": { width: 1116, height: 685, zoom: 0.7 }, "9 x 5.5 นิ้ว": { width: 1116, height: 806, zoom: 0.7 },
};
const padding = {
  A4: { paddingLeft: 24, paddingRight: 24, paddingTop: 24, paddingBottom: 24 }, A5: { paddingLeft: 24, paddingRight: 24, paddingTop: 24, paddingBottom: 24 },
  "4.5 x 5.5 นิ้ว": { paddingLeft: 24, paddingRight: 24, paddingTop: 24, paddingBottom: 24 }, "9 x 11 นิ้ว": { paddingLeft: 24, paddingRight: 24, paddingTop: 24, paddingBottom: 24 }, "9 x 5.5 นิ้ว": { paddingLeft: 24, paddingRight: 48, paddingTop: 32, paddingBottom: 32 },
};

export default class RecieptByRoom extends DocumentSettingBase {
  documentKey = "invoice_by_room";
  redirectTo = "/invoice-by-room";

  state = { ...DocumentSettingBase.INITIAL_STATE, modal_text: false, modal_qrcode: false, text: "", type: "", document_data: null, 
    setting: { size: "A4", paddingLeft: 24, paddingRight: 24, paddingTop: 24, paddingBottom: 24, header_1: { status: true, title: "-รูปภาพ" }, header_2: { status: true, title: "" }, header_3: { status: true, title: "" }, header_4: { status: true, title: "-ใบแจ้งหนี้ค่าน้ำ/ค่าใช้จ่ายส่วนกลาง" }, header_5: { status: true, title: "-เลขที่ใบแจ้งหนี้" }, header_6: { status: true, title: "-วันที่แจ้งหนี้" }, header_7: { status: true, title: "-ชื่อ-นามสกุล" }, th_1: { status: true, title: "-เลขมาตร เดือนนี้" }, th_2: { status: true, title: "-เลขมาตร เดือนก่อน" }, th_3: { status: true, title: "-หน่วยที่ใช้" }, th_4: { status: true, title: "-ค่าน้ำประปา" }, th_5: { status: true, title: "-ค่าบริการอุปกรณ์" }, th_6: { status: true, title: "-ค่าขยะ" }, th_7: { status: true, title: "-ค่าส่วนกลาง" }, th_8: { status: true, title: "-ค่าเบี้ยประกัน" }, th_9: { status: true, title: "-ค่าเคเบิล" }, th_10: { status: true, title: "-เพิ่ม/ลดหนี้" }, th_11: { status: true, title: "-ค่าต่อมิเตอร์" }, th_12: { status: true, title: "-เบี้ยปรับ" }, th_13: { status: true, title: "-ค่าใช้จ่ายปัจจุบัน" }, th_14: { status: true, title: "-งวดค้าง" }, th_15: { status: true, title: "-จำนวนเงินค้างชำระ" }, tr_1: { status: true, title: "-ข้อมูลในตาราง" }, tr_4: { status: true, title: "-รวมเป็นเงิน" }, tr_5: { status: true, title: "-ปรับปรุงยอดเงิน" }, tr_6: { status: true, title: "-รวมเป็นเงินทั้งสิ้น" }, footer_1: { status: true, title: "-รวมเป็นเงิน" }, footer_2: { status: true, title: "" }, footer_3: { status: true, title: "-ลงชื่อ" }, footer_4: { status: true, title: "" }, footer_5: { status: true, title: "" }, footer_6: { status: true, title: "" }, footer_7: { status: true, title: "" }, footer_8: { status: true, title: "" }, footer_9: { status: true, title: "" } }
  };

  renderPadInput = (label, key) => (
    <div className="w-100 pr-1">
      <div className="pr-2 text-nowrap wpx-100">{label}</div>
      <input type="text" className="form-control" value={this.state.setting[key]} onChange={(e) => float(e.target.value) && this.setState(s => ({ setting: { ...s.setting, [key]: e.target.value } }))} />
    </div>
  );

  render() {
    const s = this.state.setting;
    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ตั้งค่า" page3="ใบแจ้งหนี้ตามห้อง" />
        <div className="body p-3">
          <h4><b>ใบแจ้งหนี้ตามห้อง</b></h4>
          <div className="d-flex">
            <div style={{ width: 816.38 }}>
              <div className={`mx-auto bg-white ${s.size === "9 x 5.5 นิ้ว" ? "pdf-small" : "pdf"}`} style={{ ...size[s.size || "A4"], paddingLeft: Number(s.paddingLeft), paddingRight: Number(s.paddingRight), paddingTop: Number(s.paddingTop), paddingBottom: Number(s.paddingBottom) }}>
                <table className="table table-bordered mb-0">
                  <tbody>
                    <tr className={s.header_1.status||s.header_2.status||s.header_3.status||s.header_4.status||s.header_5.status||s.header_6.status ? "" : "d-none"}>
                      <td rowSpan={2} className="border-bottom-0"><div className="d-flex align-items-center"><img src={getStorage("picture_paper") || LOGO} style={{ width: 100, height: 100, objectFit: "contain", marginRight: 6 }} alt="LOGO" className={`bg-contain${this.dNone("header_1")}`} /><div><h2 className={`fw-bold px-2 mb-0${this.dNone("header_2")}`}>{s.header_2.title}</h2><div className={`px-2${this.dNone("header_3")}`}>{s.header_3.title.split("\n").map((e,i) => <div key={i}>{e}</div>)}</div></div></div></td>
                      <td className={`wpx-250 text-center border-bottom-0${this.dNone("header_4")} ${this.dNone("header_5")} ${this.dNone("header_6")}`}><h4 className="fw-bold mb-0">ใบแจ้งหนี้ค่าน้ำ/ค่าใช้จ่ายส่วนกลาง</h4></td>
                    </tr>
                    <tr className={s.header_1.status||s.header_2.status||s.header_3.status||s.header_4.status||s.header_5.status||s.header_6.status ? "" : "d-none"}>
                      <td className="border-bottom-0 wpx-250"><div className={this.dNone("header_5")}>เลขที่ : IW1000000001</div><div className={this.dNone("header_6")}>วันที่ : {format_date(new Date(), "dd mmmm yyyy")}</div></td>
                    </tr>
                    <tr className={s.header_7.status ? "" : "d-none"}>
                      <td className="border-bottom-0" colSpan={2}><h4 className="fw-bold mb-0">ชื่อ-นามสกุล : นายสมมติ นามสกุลสมมติ</h4></td>
                    </tr>
                  </tbody>
                </table>
                <table className="table table-bordered mb-0">
                  <tbody>
                    <tr>{[s.th_1, s.th_2, s.th_3, s.th_4, s.th_5, s.th_6, s.th_7, s.th_8, s.th_9, s.th_10, s.th_11, s.th_12, s.th_13, s.th_14, s.th_15].map((t, i) => t.status && <td key={i} className="py-1 text-center">{t.title.replace("-", "")}</td>)}</tr>
                    <tr className={this.dNone("tr_1")}>{[...Array(15)].map((_, i) => <td key={i} className="py-1 text-center">0</td>)}</tr>
                  </tbody>
                </table>
                <table className="table table-bordered mb-0">
                  <tbody>
                    <tr className={this.dNone("tr_4")}><td className="text-right pr-1 border-0">รวมเป็นเงิน</td><td className="text-right">0.00</td></tr>
                    <tr className={this.dNone("tr_5")}><td className="text-right pr-1 border-0">ปรับปรุงยอดเงิน</td><td className="text-right">0.00</td></tr>
                    <tr className={this.dNone("tr_6")}><td className="text-right pr-1 border-0">รวมเป็นเงินทั้งสิ้น</td><td className="text-right">0.00</td></tr>
                  </tbody>
                </table>
                <table className={`table table-bordered mb-0${this.dNone("footer_2")}`}>
                  <tbody>
                    <tr><td className="border-top-0 text-right"><div className="d-flex justify-content-end"><h3 className="fw-bold d-flex mb-0">รวมทุกรายการเป็นเงินทั้งสิ้น 431.03 บาท</h3></div></td></tr>
                    <tr><td className="py-1 border-top-0 text-center">{s.footer_2.title}</td></tr>
                  </tbody>
                </table>
                <div className={`mb-5 mt-2${this.dNone("footer_3")}`}>{s.footer_3.title.split("\n").map((e, i) => <div key={i}>{e}</div>)}</div>
                <div className="d-flex w-100">
                  <div className="w-100">
                    <div className={`fw-bold text-danger text-30 mb-4${this.dNone("footer_4")}`}>{s.footer_4.title}</div>
                    <div className={`fw-bold text-danger text-30 mb-4${this.dNone("footer_5")}`}>{s.footer_5.title}</div>
                    <div className={`fw-bold text-primary text-30${this.dNone("footer_6")}`}>{s.footer_6.title}</div>
                  </div>
                  <div className="wpx-350 text-center">
                    <div className="w-100 d-flex justify-content-center mb-3">
                      {s.footer_7.title && <img src={`data:image/png;base64,${s.footer_7.title}`} style={{ width: 150, height: 150, objectFit: "contain", marginRight: 6 }} alt="QR Code" className={`bg-contain mx-2${this.dNone("footer_7")}`} />}
                      {s.footer_8.title && <img src={`data:image/png;base64,${s.footer_8.title}`} style={{ width: 150, height: 150, objectFit: "contain", marginRight: 6 }} alt="QR Code" className={`bg-contain mx-2${this.dNone("footer_8")}`} />}
                    </div>
                    <div className={`text-center w-100${this.dNone("footer_9")}`}>{s.footer_9.title}</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-3 mt-4">
              <h5 className="fw-bold">ขนาดกระดาษ</h5>
              <select className="form-control mb-2" value={s.size} onChange={(e) => this.setState(prev => ({ setting: { ...prev.setting, size: e.target.value, ...padding[e.target.value] } }))}>
                {Object.keys(size).map(sz => <option key={sz} value={sz}>{sz}</option>)}
              </select>
              <div className="d-flex mb-2">{this.renderPadInput("ด้านซ้าย", "paddingLeft")}{this.renderPadInput("ด้านขวา", "paddingRight")}{this.renderPadInput("ด้านบน", "paddingTop")}{this.renderPadInput("ด้านล่าง", "paddingBottom")}</div>
              <div className="d-flex flex-wrap">
                <div className="py-2 px-2">{this.renderSwitch("โลโก้", "header_1")}{this.renderSwitch("โครงการ", "header_2", true)}{this.renderSwitch("ที่อยู่", "header_3", true)}{this.renderSwitch("ใบแจ้งหนี้", "header_4")}{this.renderSwitch("เลขที่", "header_5")}{this.renderSwitch("วันที่", "header_6")}{this.renderSwitch("ชื่อ-สกุล", "header_7")}</div>
                <div className="py-2 px-2">{["th_1","th_2","th_3","th_4","th_5","th_6","th_7","th_8","th_9","th_10","th_11","th_12","th_13","th_14","th_15"].map(k => this.renderSwitch(s[k].title.replace("-",""), k))}</div>
                <div className="py-2 px-2">{this.renderSwitch("ข้อมูลตาราง", "tr_1")}{this.renderSwitch("รวมเงิน", "tr_4")}{this.renderSwitch("ปรับปรุงยอด", "tr_5")}{this.renderSwitch("รวมสิ้นสุด", "tr_6")}</div>
                <div className="py-2 px-2">{["footer_1","footer_2","footer_3","footer_4","footer_5"].map(k => this.renderSwitch(k==="footer_1"?"ตัวอักษร":s[k].title.replace("-",""), k, k!=="footer_3"))}</div>
                <div className="d-flex flex-wrap mb-1">
                        <div className="wpx-120 d-flex">
                          QRcode ธนาคาร
                          <label
                            className="wpx-20 hpx-20 bg-warning-light rounded-1 d-flex align-items-center justify-content-center icon text-warning pointer mx-1"
                            onClick={() => {
                              this.setState({
                                modal_qrcode: true,
                                text: this.state.setting.footer_7.title,
                                type: "footer_7",
                              });
                            }}
                          >
                            {"\uf304"}
                          </label>
                        </div>
                        <Switch
                          height={20}
                          width={40}
                          onChange={(e) => {
                            this.UpdateStatus("footer_7");
                          }}
                          checked={this.state.setting.footer_7.status}
                        />
                      </div>
                      <div className="d-flex flex-wrap mb-1">
                        <div className="wpx-120 d-flex">
                          QRcode ไลน์
                          <label
                            className="wpx-20 hpx-20 bg-warning-light rounded-1 d-flex align-items-center justify-content-center icon text-warning pointer mx-1"
                            onClick={() => {
                              this.setState({
                                modal_qrcode: true,
                                text: this.state.setting.footer_8.title,
                                type: "footer_8",
                              });
                            }}
                          >
                            {"\uf304"}
                          </label>
                        </div>
                        <Switch
                          height={20}
                          width={40}
                          onChange={(e) => {
                            this.UpdateStatus("footer_8");
                          }}
                          checked={this.state.setting.footer_8.status}
                        />
                      </div>
                      <div className="d-flex flex-wrap mb-1">
                        <div className="wpx-120 d-flex">
                          ชื่อบัญชี
                          <label
                            className="wpx-20 hpx-20 bg-warning-light rounded-1 d-flex align-items-center justify-content-center icon text-warning pointer mx-1"
                            onClick={() => {
                              this.setState({
                                modal_text: true,
                                text: this.state.setting.footer_9.title,
                                type: "footer_9",
                              });
                            }}
                          >
                            {"\uf304"}
                          </label>
                        </div>
                        <Switch
                          height={20}
                          width={40}
                          onChange={(e) => {
                            this.UpdateStatus("footer_9");
                          }}
                          checked={this.state.setting.footer_9.status}
                        />
                      </div>
              </div>
              <button className="btn btn-primary w-100" onClick={this.Update}>บันทึก</button>
            </div>
          </div>
        </div>

        {this.renderTextModal()}

        <Modal show={this.state.modal_qrcode} onHide={() => this.setState({ modal_qrcode: false })}>
          <Modal.Header><Modal.Title><b>แก้ไข</b></Modal.Title></Modal.Header>
          <Modal.Body>
            {this.state.text ? (
              <div className="card p-3 align-items-center text-center w-100 position-relative">
                <img alt="qrcode" src={`data:image/png;base64,${this.state.text}`} className="wpx-200 img-responsive" />
                <div className="wpx-32 hpx-32 rounded-circle bg-danger text-white icon text-24 d-flex justify-content-center align-items-center position-absolute pointer" style={{ right: -6, top: -6 }} onClick={() => this.setState({ text: "" })}>{""}</div>
              </div>
            ) : (
              <button className="btn btn-outline-primary w-100" onClick={() => document.getElementById("qrcode_file").click()}>นำเข้าไฟล์</button>
            )}
            <input className="d-none" id="qrcode_file" type="file" accept="image/*" onChange={(e) => Resizer.imageFileResizer(e.target.files[0], 128, 128, "JPG", 100, 0, (uri) => this.setState({ text: uri.split(",")[1] }), "base64")} />
            <button className="btn btn-primary w-100 mt-3" onClick={() => { let set = { ...this.state.setting }; set[this.state.type].title = this.state.text; this.setState({ setting: set, modal_qrcode: false }); }}>บันทึก</button>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}